<div class="card border-secondary mb-6" style="max-width: 100%;">
  <div class="card-header">HttpRequestCache</div>
  <div class="card-body text-secondary">
    <h4 class="card-title">Httpリクエストの結果をキャッシュするサンプル</h4>
    <div class="card-text">
      <p>
        Httpリクエストの結果をキャッシュし同じパラメータであればHttpリスエストを送信しない
      </p>
      <p>
        Httpリクエスト送信時にInterceptorでSubjectに通信内容を流しているので通信が発生するとログに出力される
      </p>
    </div>
  </div>
</div>

<div>
  <button type="button" (click)="getHeroes()" class="btn btn-sm btn-primary">
    GetHeroes
  </button>
  <div class="d-flex flex-column mb-3">
    <div
      class="d-flex flex-row bg-light border border-dark"
      *ngFor="let hero of heroes$ | async"
      aria-label="heroes"
    >
      <div class="p-2" aria-label="id">{{ hero.id }}</div>
      <div class="p-2" aria-label="name">{{ hero.name }}</div>
    </div>
  </div>
</div>

<ng-container *ngFor="let n of [1, 2, 3, 4]">
  <button type="button" (click)="getHero(n)" class="btn btn-sm btn-success">
    Get Hero(id: {{ n }})
  </button>
</ng-container>

<div class="card">
  <div>CurrentHero</div>
  <div
    class="d-flex flex-row bd-highlight border border-dark"
    aria-label="hero"
  >
    <div class="p-2" aria-label="id">{{ (hero$ | async)?.id }}</div>
    <div class="p-2" aria-label="name">{{ (hero$ | async)?.name }}</div>
  </div>
</div>

<br />
<!--<button type="button" (click)="getUsers()" class="btn btn-sm btn-primary">-->
<!--  Users-->
<!--</button>-->
<!--<button type="button" (click)="getUsers2()" class="btn btn-sm btn-primary">-->
<!--  Users2-->
<!--</button>-->

<!--<button-->
<!--  type="button"-->
<!--  (click)="getUsersWithParams()"-->
<!--  class="btn btn-sm btn-primary"-->
<!--&gt;-->
<!--  UsersWithParams-->
<!--</button>-->

<div>Http Request Logs</div>
<alert type="info">
  <div *ngFor="let log of logs">
    <span aria-label="url">
      {{ log.message }}
    </span>
    <span aria-label="status">
      {{ log.data?.status }}
    </span>
    <span aria-label="ok">
      {{ log.data?.ok }}
    </span>
  </div>
</alert>

<!--<ng-container *ngFor="let user of users">-->
<!--  <hr />-->
<!--  {{ user | json }}-->
<!--</ng-container>-->
